const titleRoutings = [
    {
        url: '/',
        title: 'Etusivu',
        description: 'Oletko miettinyt, miten saada parempia arvosanoja koulusta? Essee.tk on tekoäly, joka kirjoittaa esseitä, tietotekstejä, kirjoitelmia ja muita tekstejä. Kokeile esseegeneraattoria!'
    },
    {
        url: '/info',
        title: 'Tietoa',
        description: 'Mikä ihme Essee.tk on? No, kärjistetysti se on työkalu, jonka avulla voit tehdä esseitä ilman, että kirjoitat niitä. Kurkkaa lisää!'
    },
    {
        url: '/tekoaly',
        title: 'Tekoäly',
        desciption: 'Essee.tk:n tekoälypalvelu on nyt avoinna! Tule chattaamaan tekoälyn kanssa, ja katso, mihin nykyaikaiset ohjelmistot pystyvät. Ja mikä parasta, tekoälyn testaaminen on täysin ilmaista!'
    },
    {
        url: '/kielet',
        title: 'Kielten essee',
        description: 'Essee.tk:n avulla voi myöskin luoda mm. englanninkielisiä esseitä ja kirjoitelmia. Essee.tk on työkalu, jonka avulla voit saada parempia numeroita. Kokeile ilmaiseksi!'
    },
    {
        url: '/kielet/parempia-arvosanoja',
        title: 'Parempia arvosanoja kielistä',
        description: 'Tiedätkö, miten voisit saada parempia arvosanoja kielistä, kuten englannista, ruotsista tai saksasta? Listasimme parhaimmat vinkit sivullemme. Tervetuloa lukemaan!'
    },
    {
        url: '/kielet/englanti',
        title: 'Englanninkielinen essee',
        description: 'Oletko miettinyt, miten saada parempia numeroita englannista? Essee.tk tarjoaa mahdollisuuden mm. englanninkielisten esseiden luomiseen. Testaa sitä!'
    },
    {
        url: '/fysiikka',
        title: 'Fysiikka',
        description: 'Fysiikka on vaikeaa. Oletko koskaan miettinyt, miten saada parempia numeroita Fysiikasta? Tiedätkö, miten laskea potentiaalienergia? Kiinnostaako sinua fysiikka? Laske fysiikan laskut nettisivumme avulla.'
    },
    {
        url: '/lunttilappu',
        title: 'Lunttilappu',
        description: 'Lunttilappu-ohjelman avulla voit muistaa paljon enemmän asioita, kuin muuten muistaisit. Lunttilappu tallentaa kaikki kirjoituksesi automaattisesti selaimellesi. Lunttilapun avulla voit saada parempia numeroita!'
    },
    {
        url: '/fysiikka/teho',
        title: 'Teholaskuri',
        description: 'Oletko miettinyt, miten teho lasketaan? Etkö ole lainkaan tehokas ihminen, etkä jaksaisi laskea tehoa? Sivulta löytyy laadukas teholaskuri, jonka avulla voit saada vastauksen: miten teho lasketaan?.'
    },
    {
        url: '/fysiikka/potentiaalienergia',
        title: 'Potentiaalienergialaskuri',
        description: 'Potentiaalienergia on energia, joka on ikään kuin sitoutunut kappaleen paikkaan. Etkö jaksa laskea potentiaalienergialaskuja? Käytä potentiaalienergialaskinta. Fysiikka on helppoa sivustomme avulla!'
    },
    {
        url: '/fysiikka/nosto',
        title: 'Nostotyölaskuri',
        description: 'Tiedätkö, miten nostotyö lasketaan? Nostotyön voi laskea laskureillamme. Joskus nostaminen voi olla todella työlästä, mutta sivustomme avulla siihen liittyvän työn laskeminen ei ole.'
    },
    {
        url: '/alykkyys',
        title: 'Älykkyystesti',
        description: 'Haluatko tietää älykkyysosamääräsi? Essee.tk:n avulla voit nyt laskea luotettavasti älykkyysosamääräsi muutaman yksinkertaisen kysymyksen perusteella. Saat testin tuloksena älykkyysosamääräsi tietoosi.'
    },
    {
        url: '/tekoaly/chat',
        title: 'Tekoäly-chat',
        desciption: 'Oletko kirjoitustaidoton? Ei se mitään, sillä Essee.tk:n tekoäly voi kirjoittaa sinulle mitä haluat - maasta taivaaseen. Kokeile nyt algoritmiamme!'
    },
    {
        url: '/tekoaly/kuva',
        title: 'Kuvageneraattori',
        description: 'Etkö osaa piirtää? Ei haittaa, sillä Essee.tk luo sinulle mieleisen kuvan tai piirroksen haluamastasi tekstistä. Nyt sinun ei tarvitse piirrellä kuvaamataidon tunneille, vaan voit käyttää Essee.tk:ta! Kokeile nyt!'
    }
]

module.exports = { titleRoutings }